import { z } from 'zod'

export const tasksContextSearchSchema = z.object({
  page: z.coerce.number().int().min(0).optional(),
  size: z.coerce.number().int().positive().optional(),
  sort: z.string().optional(),
  direction: z.enum(['ASC', 'DESC']).optional(),
  search: z.string().optional()
})
